module.exports = __webpack_public_path__ + "img/f1-3.44eac280.png";